export enum CouponBucket {
  Actives = "actives",
  Inactive = "inactive",
  Finished = "finished",
}

export enum CouponUiState {
  Active = "active",
  Inactive = "inactive",
  Finished = "finished",
}

export enum CouponDiscountType {
  Percentage = "percentage",
  Value = "value",
}

export enum CouponScope {
  Store = "store",
  Products = "products",
}

export enum CouponPurchaseCondition {
  None = "none",
  FirstOrder = "first_order",
  MinPurchase = "min_purchase",
}

export const COUPON_FILTER_OPTIONS = [
  CouponBucket.Actives,
  CouponBucket.Inactive,
  CouponBucket.Finished,
] as const;

export const MAX_COUPON_PRODUCTS = 5;

export const COUPON_OFFER_TYPE = "coupon";
export const COUPON_OWNER_TYPE = "store";
